import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/**
 * Horizontal rule separator: "ou com email" — .pen divider.
 */
export function AuthOrDivider({ className }) {
  return (
    <div
      className={cn('flex items-center gap-space-3', className)}
      role="separator"
    >
      <span className="h-px flex-1 bg-border" aria-hidden />
      <span className="type-label text-muted-foreground">{pt.auth.google.orDivider}</span>
      <span className="h-px flex-1 bg-border" aria-hidden />
    </div>
  );
}
